let Widget3dsoft = require('./Main.js');

/**
 * On utilise le meme formulaire pour un nouveau clientque pour la modification
 * @param bShowClientRequired Si true alors on affiche "Un client doit Ãªtre choisi pour poursuivre"
 * @param bModif On utilise le formulaire pour de la modif
 * @returns {undefined}
 */
Widget3dsoft.prototype.showFormNewClient = function (bShowClientRequired, bModif, iIdClient,bModifNewRdv) {
    var self = this;
    
    $(self.sClass + ' .widget3Dsoft-loading').show();
    if (bShowClientRequired === undefined) {
        bShowClientRequired = false;
    }
    if (bModifNewRdv === undefined) {
        bModifNewRdv = false;
    }

    //var self = this;
    //this.rendezvous.nom = '';
    //this.rendezvous.sPrenom = '';
    
    
    if(self.sHtmlFormClient != undefined){
        self.htmlCompleteFormNewClient(self,self.sHtmlFormClient, bShowClientRequired,bModif,iIdClient,bModifNewRdv);
        $(self.sClass + ' .widget3Dsoft-loading').hide();
        self.bAjaxTermine3Dsoft = true;
    }else{
        self.ajax('GET',
            self.sServerURL + 'widget/form-new-client' + self.sParamsGet,
            {
            },
            function (response) {
                $(self.sClass + ' .widget3Dsoft-loading').hide();
                self.sHtmlFormClient = response;
                self.htmlCompleteFormNewClient(self,response, bShowClientRequired,bModif,iIdClient,bModifNewRdv);
                
                self.bAjaxTermine3Dsoft = true;
            });
    }

};

Widget3dsoft.prototype.htmlCompleteFormNewClient = function(self,sHtml, bShowClientRequired, bModif,iIdClient,bModifNewRdv){
   
    $(self.sClass).html(sHtml);
    $(self.sClass + ' .widget3Dsoft-tel').val(self.rendezvous.tel);

    var civilite = (self.rendezvous.civilite === null) ? '' : self.rendezvous.civilite;
    var sPrenom = (self.rendezvous.sPrenom === null) ? '' : self.rendezvous.sPrenom.substr(0, 1).toUpperCase() + self.rendezvous.sPrenom.substr(1).toLowerCase();
    var sNom = (self.rendezvous.sNom === null) ? '' : self.rendezvous.sNom.toUpperCase();
    var telbur = (self.rendezvous.telbur === null) ? '' : self.rendezvous.telbur;
    var teldom = (self.rendezvous.teldom === null) ? '' : self.rendezvous.teldom;
    var telmob = (self.rendezvous.telmob === null) ? '' : self.rendezvous.telmob;
    var email = (self.rendezvous.email === null) ? '' : self.rendezvous.email;
    var adresse = (self.rendezvous.adresse === null) ? '' : self.rendezvous.adresse;
    var adresse2 = (self.rendezvous.adresse2 === null) ? '' : self.rendezvous.adresse2;
    var cp = (self.rendezvous.cp === null) ? '' : self.rendezvous.cp;
    var ville = (self.rendezvous.ville === null) ? '' : self.rendezvous.ville;
                
                $(self.sClass + ' .widget3Dsoft-nom').val(sNom);
                $(self.sClass + ' .widget3Dsoft-prenom').val(sPrenom);
                $(self.sClass + ' .widget3Dsoft-telbur').val(telbur);
                $(self.sClass + ' .widget3Dsoft-teldom').val(teldom);
                $(self.sClass + ' .widget3Dsoft-telmob').val(telmob);
                $(self.sClass + ' .widget3Dsoft-email').val(email);
                $(self.sClass + ' .widget3Dsoft-adresse').val(adresse);
                $(self.sClass + ' .widget3Dsoft-adresse2').val(adresse2);
                $(self.sClass + ' .widget3Dsoft-cp').val(cp);
                $(self.sClass + ' .widget3Dsoft-ville').val(ville);
               

                $(self.sClass + ' .widget3Dsoft-nom').keyup(function () {
                    $(self.sClass + ' .widget3Dsoft-nom').val($(self.sClass + ' .widget3Dsoft-nom').val().toUpperCase());
                });

                $(self.sClass + ' .widget3Dsoft-prenom').keyup(function () {
                    $(self.sClass + ' .widget3Dsoft-prenom').val($(self.sClass + ' .widget3Dsoft-prenom').val().substr(0, 1).toUpperCase() + $(self.sClass + ' .widget3Dsoft-prenom').val().substr(1).toLowerCase());
                });

                //Retrieve civilites for the select
                self.retrieveCivilites(function (aCivilites) {
                    for (iIdCivilite in aCivilites) {
                        var select = '';

                        if (civilite == aCivilites[iIdCivilite].id ) {
                            select = "selected='selected'";
                        }

                        $(self.sClass + ' .widget3Dsoft-civilite').append('<option value="' + aCivilites[iIdCivilite].id + '" '+select+'>' + aCivilites[iIdCivilite].abrege + '</option>');
                    }
                    
                });

                self.filArianne(self,'stepClient');
                if (bShowClientRequired) {
                    $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.WIDGET_MSG_COMPLETE_CLIENT);
                    $(self.sClass + ' .widget3Dsoft-message').show();
                }
                self.headerProfil(self);
                self.completeFooter();
               
                if (bModif) {
                    //in just modification we hide the breadcrumb
                    $(self.sClass + ' .stepVehicule').hide();
                    $(self.sClass + ' .stepMotif').hide();
                    $(self.sClass + ' .stepDate').hide();
                    $(self.sClass + ' .stepValidation').hide();
                }
                
                if(bModif || bModifNewRdv){
                    self.rendezvous.iIdClient = iIdClient;
                    $(self.sClass + ' .widget3Dsoft-btnReturnWelcomePage').show().click(function(){
                        self.showFormSearchClient();
                    });
                    $(self.sClass + ' h1').html(self.sLanguage.CLIENT_MSG_MODIFIER_CLIENT);
                    $(self.sClass + ' .widget3Dsoft-civilite').val(self.aClients[iIdClient].civilite);
                    $(self.sClass + ' .widget3Dsoft-nom').val(self.aClients[iIdClient].nom);
                    $(self.sClass + ' .widget3Dsoft-prenom').val(self.aClients[iIdClient].prenom);
                    $(self.sClass + ' .widget3Dsoft-teldom').val(self.aClients[iIdClient].tel_dom);
                    $(self.sClass + ' .widget3Dsoft-telbur').val(self.aClients[iIdClient].tel_bur);
                    $(self.sClass + ' .widget3Dsoft-telmob').val(self.aClients[iIdClient].tel_gsm);
                    $(self.sClass + ' .widget3Dsoft-email').val(self.aClients[iIdClient].email);
                    $(self.sClass + ' .widget3Dsoft-adresse').val(self.aClients[iIdClient].adresse1);
                    $(self.sClass + ' .widget3Dsoft-adresse2').val(self.aClients[iIdClient].adresse2);
                    $(self.sClass + ' .widget3Dsoft-cp').val(self.aClients[iIdClient].code_postal);
                    $(self.sClass + ' .widget3Dsoft-ville').val(self.aClients[iIdClient].ville);

                    //Champs non modifiables
                    $(self.sClass + ' .widget3Dsoft-civilite').prop('disabled', 'disabled');
                    $(self.sClass + ' .widget3Dsoft-nom').prop('disabled', 'disabled');
                    $(self.sClass + ' .widget3Dsoft-prenom').prop('disabled', 'disabled');
                    //$(self.sClass + ' .widget3Dsoft-teldom').prop('disabled', 'disabled');
                    //$(self.sClass + ' .widget3Dsoft-telbur').prop('disabled', 'disabled');
                    //$(self.sClass + ' .widget3Dsoft-telmob').prop('disabled', 'disabled');
                    //$(self.sClass + ' .widget3Dsoft-email').prop('disabled', 'disabled');
                    $(self.sClass + ' .widget3Dsoft-adresse').prop('disabled', 'disabled');
                    $(self.sClass + ' .widget3Dsoft-adresse2').prop('disabled', 'disabled');
                    $(self.sClass + ' .widget3Dsoft-cp').prop('disabled', 'disabled');
                    $(self.sClass + ' .widget3Dsoft-ville').prop('disabled', 'disabled');

                    //Mettre en mode update
                    $(self.sClass + ' .widget3Dsoft-mode').val('update');
                } else {
                    self.rendezvous.iIdClient = null;
                }

                

                 
                $('.showFormSearchClient').click(function(){self.showFormSearchClient();});
                $('.validateClientRendezVous').click(function(){self.validateClientRendezVous(self,bModif);});
                self.adaptDimensions(self);
}

/**
 * 
 * @returns {Array|response.aCivilites|aCivilites}
 */
Widget3dsoft.prototype.retrieveCivilites = function (callback) {
    var self = this;
    var aCivilites = [];

    if(self.aCivilites != undefined ){
        callback(self.aCivilites);
    }else{
        self.aCivilites = [];
        self.ajax('GET',
                this.sServerURL + 'rest/client/civilites' + this.sParamsGet,
                {
                },
                function (response) {
                    if (bIEOld3Dsoft) {
                        response = JSON.parse(response);
                    }
                    if (response.success == true) {
                        self.aCivilites = response.aCivilites;
                        callback(response.aCivilites);
                    }
                },true);
    }
};

/**
 * 
 * @param {type} iIdClient
 * @param widget3Dsoft self
 * @returns {undefined}
 */
Widget3dsoft.prototype.validateClientRendezVous = function (self,bReturnToWelcome) {
    var bValidNewClient = true;
    $(self.sClass + ' .widget3Dsoft-message').html('');

    //Champs obligatoires
    self.rendezvous.civilite = $(self.sClass + ' .widget3Dsoft-civilite').val();

    if ($(self.sClass + ' .widget3Dsoft-nom').val() !== '') {
        self.rendezvous.sNom = $(self.sClass + ' .widget3Dsoft-nom').val();
    } else {
        bValidNewClient = false;
        $(self.sClass + ' .widget3Dsoft-message').append('<p class="margin-none">' + self.sLanguage.CLIENT_MSG_NOM_OBLIGATOIRE + '</p>');
        $(self.sClass + ' .widget3Dsoft-nom').addClass('error');
    }

    self.rendezvous.sPrenom = $(self.sClass + ' .widget3Dsoft-prenom').val();
    self.rendezvous.teldom = $(self.sClass + ' .widget3Dsoft-teldom').val();
    self.rendezvous.telbur = $(self.sClass + ' .widget3Dsoft-telbur').val();
    self.rendezvous.telmob = $(self.sClass + ' .widget3Dsoft-telmob').val();
    self.rendezvous.email = $(self.sClass + ' .widget3Dsoft-email').val();
    self.rendezvous.adresse = $(self.sClass + ' .widget3Dsoft-adresse').val();
    self.rendezvous.adresse2 = $(self.sClass + ' .widget3Dsoft-adresse2').val();
    self.rendezvous.cp = $(self.sClass + ' .widget3Dsoft-cp').val();
    self.rendezvous.ville = $(self.sClass + ' .widget3Dsoft-ville').val();
    
    //For next search
    self.oSearchClient.sTel = self.rendezvous.telmob;
    self.oSearchClient.sNom = self.rendezvous.sNom;
    self.oSearchClient.sPrenom = self.rendezvous.sPrenom ;
    //self.oSearchClient.sImmatriculation = 
    //self.oSearchClient.sVin = 

        
    
    //bValidNewClient is false if required fields are empty
    if (bValidNewClient) {
        if ($(self.sClass + ' .widget3Dsoft-mode').val() == 'update') {

            //On test si une valeur a changé 
            var iIdClient = self.rendezvous.iIdClient;

            if (self.rendezvous.telmob != self.aClients[iIdClient].tel_gsm
                    || self.rendezvous.teldom != self.aClients[iIdClient].tel_dom
                    || self.rendezvous.telbur != self.aClients[iIdClient].tel_bur
                    || self.rendezvous.email != self.aClients[iIdClient].email) {

                self.updateClient(self, function () {
                    
                    if(bReturnToWelcome){
                        self.showFormSearchClient();
                    }else{
                        self.showFormVehicule();
                    }
                    
                });
            } else {
                if(bReturnToWelcome){
                        self.showFormSearchClient();
                }else{
                        self.showFormVehicule();
                }
            }

        } else {
            //new client
            self.showFormVehicule();
        }


    } else {
        $(self.sClass + ' .widget3Dsoft-message').show();
    }
};


Widget3dsoft.prototype.updateClient = function (self, callback) {
    self.ajax('POST',
            self.sServerURL + 'rest/client/update' + self.sParamsGet,
            self.rendezvous,
            function (response) {
                callback();
            },true);
}

/**
 * Si on est pas passÃ© par l'Ã©tape client on affiche le formulaire pour crÃ©er un client
 * et on retourne false
 * Sinon on retourne true
 * @returns {Boolean}
 */
Widget3dsoft.prototype.verifStepClientDone = function () {
    if (this.rendezvous.iIdClient === null && (this.rendezvous.nom === null || this.rendezvous.nom === "")) {
        this.showFormNewClient(true);
        return false;
    }
    return true;
}

/**
 * 
 * @param {type} iAnnee
 * @param {type} iMonth
 * @returns {unresolved}
 */
Widget3dsoft.prototype.getNbDaysOfMonth = function (iAnnee, iMonth) {
    var oDate = new Date(iAnnee, iMonth, 1, 1, 2, 1, 1);
    oDate.setTime(oDate.getTime() - 24 * 60 * 60 * 1000);
    return nbjomois = oDate.getDate();
}

/**
* 
* @param {type} iIdClient
* @param widget3Dsoft self
* @returns {undefined}
*/
Widget3dsoft.prototype.createNouveauClientRendezVous = function (self) {
        self.updateRdvActif = false;
        self.initRdv(self);
        self.showFormNewClient();
    };